import React, { useState } from 'react';
import {
  CloseButton,
  Dialog,
  DialogBackdrop,
  DialogPanel,
} from '@headlessui/react';
import { Cross } from '../ui/Icons';

export default function Sidebar({
  sidebarSizeClass = 'max-w-full sm:max-w-87',
  sidebarButtonClasses = 'btn btn-primary text-base px-4 gap-x-6 py-3.5 leading-none',
  sidebarButtonContent,
  sidebarTitle,
  sidebarPanelContent,
  closeButtonText,
}: {
  sidebarSizeClass?: string,
  sidebarButtonClasses?: string,
  sidebarButtonContent: JSX.Element,
  sidebarTitle: string | JSX.Element,
  sidebarPanelContent: JSX.Element,
  closeButtonText: string,
}) {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <>
      <button
        type="button"
        className={sidebarButtonClasses}
        onClick={() => setShowSidebar(!showSidebar)}
      >
        {sidebarButtonContent}
      </button>
      <Dialog open={showSidebar} onClose={setShowSidebar} className="relative z-9999">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-near-black/50 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />
        <div className="fixed-inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className={`pointer-event-none fixed inset-y-0 right-0 flex ${sidebarSizeClass}`}>
              <DialogPanel
                transition
                className="pointer-events-auto relative w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
              >
                <div className="bg-white sm:rounded-tl-lg shadow-md-secondary w-full text-sm md:text-base h-dvh flex flex-col">
                  <div className="flex items-center gap-4 p-4 md:px-8 border-b border-light-grey-1">
                    <h3 className="text-xl md-text-2xl-secondary leading-tight flex-1.0">{sidebarTitle}</h3>
                    <CloseButton className="btn-close w-8 h-8 p-2 flex items-center justify-center transition-colors text-near-black hover:text-accent">
                      <Cross className="w-full h-full" />
                    </CloseButton>
                  </div>
                  <div className="overflow-y-auto overflow-x-hidden flex-1.0 p-4 md:py-6 md:px-8">
                    {sidebarPanelContent}
                  </div>
                  <div className="p-4 py-6 md:py6 md:px-8 bg-white shadow-button">
                    <CloseButton className="btn btn-primary w-full gap-x-1.5 py-4 leading-none">
                      {closeButtonText}
                    </CloseButton>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
